export enum NoticeKey {
  UPCOMING_EMPTY_STATE = 'upcoming_empty_state',
  CONTACTS_EMPTY_STATE = 'contacts_empty_state',
  CONTACTS_FINANCIAL_PLANNING_ONBOARDING_BANNER = 'contacts_financial_planning_onboarding_banner',
  UPCOMING_ZOOM_ONBOARDING_BANNER = 'upcoming_zoom_onboarding_banner',
  UPCOMING_EMAIL_ONBOARDING_BANNER = 'upcoming_email_onboarding_banner',
}

export interface Notice {
  key: NoticeKey
  isDismissed: boolean
  dismissedAt: string | null
}
